import loginReducer from "store/loginSlice";
import menuReducer from "store/menuSlice";
import { combineReducers } from "redux";

const allReducers = combineReducers({
  loginReducer,
  menuReducer,
});
export default allReducers;
